/* eslint-disable */
import React, { Component } from 'react'
import { TextInput, View, Image, Modal, TouchableOpacity, Text, KeyboardAvoidingView } from 'react-native'
import { SvgNoComments, SvgPush, SvgAirPlane } from '../Components/SvgComponent'
import { Fonts } from '../Themes'
import { getAvatar, isIPhoneX } from '../Lib/utils'

export default class AtTaggableInput extends Component {
  constructor(props) {
    super(props)
    this.select =[0,0]
    this.state = { modal : false }
    this.value = ''
    this.activeSearch = [ ]
  }
  collectTags = ( ) => {
    let text = this.value
    var tags = [ ]
    for( var i = 0 ; i < text.length ; ++ i ) {
      let c = text[i]
      if( c === '@' ) {
        let begin = i
        for( var j = begin; j < text.length ; ++ j ) {
          let end = text[j]
          if( end === ' ' ) {
            tags.push({ begin : begin, end : j-1 })
            break
          }
        }
        if( j === text.length ) tags.push({ begin : begin, end : text.length })
      }
    }
    return tags
  }
  processTags = ( ) => {
    let [ start, end ] = this.select
      , tags = this.collectTags ( )
    var activeTag = false
    for( var i = 0 ; i < tags.length ; ++ i ) {
      let tag = tags[i]
      if( start > tag.begin && end <= (tag.end+1) )
        activeTag = tag
    }
    this.activeTag = activeTag
    this.setState({ render : true })
  }
  onSelect = ({ nativeEvent : { text, selection : { start, end }}}) => {
    // console.log(`selection update: ${start} -> ${end}`)
    this.select = [ start, end ]
    if( end <= this.value.length )
      this.processTags ( )
  }
  onChange = ( text ) => {
    this.value = text
    this.processTags ( )
    if( this.props.change )
      this.props.change (text)

    if( this.activeTag ) {
      let search = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
      if( search.length > 2 ) {
        this.searchQuery = search
        this.props.api.searchUser({ limit : 100, user : search })
        .then(result => {
          let names = result.data.data
          if( this.activeTag ) {
            let newSearch = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
            if( newSearch === this.searchQuery )
              this.activeSearch = names
            this.setState({ render : true })
          }
        }).catch(console.log)
      }
    }
  }
  onFocus = ( ) => {
    if( this.props.focus )
      this.props.focus ( )
  }
  onSend = ( ) => {
    if( this.props.send )
      this.props.send (this.value)
    this.value = ''
  }
  insert = ( User ) => {
    let str = this.value
      , before = str.slice(0, this.activeTag.begin)
      , after = str.slice(this.activeTag.end+1)
      , next = `${before}@${User.Username}${after}`
    this.value = next
    if( after.length < 1 ) this.value += ' '
    this.setState({ render : true })
  }
  userRow = ( User ) => {
    return (<TouchableOpacity style={{ flexDirection : 'row', backgroundColor : 'white', height : 50, width : '100%' }} activeOpactiy={0.5} onPress={this.insert.bind(this,User)}>
      <Image source={{ uri: getAvatar(User.UserId) }} resizeMode='contain' style={{ width : 40, height : 40, borderRadius : 20, margin : 5 }} />
      { (User.FirstName.length > 1 || User.LastName.length > 1)
          ? <View style={{ flex : 1, flexDirection : 'column' }}>
              <Text style={{ fontSize : 15, lineHeight : 25, marginLeft : 15, color : '#4f5271' }}>{User.Username}</Text>
              <Text style={{ fontSize : 12, lineHeight : 25, marginLeft : 15, color : 'black' }}>{User.FirstName} {User.LastName}</Text>
            </View>
          : <Text style={{ fontSize : 18, lineHeight : 50, marginLeft : 15, color : '#4f5271' }}>{User.Username}</Text>
      }
    </TouchableOpacity>)
  }
  tagResults = ( ) => {
    if( ! this.activeTag ) return (<Text></Text>)
    let search = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
    const beginsWith = (a,b) => a.length > 2 && a.toLowerCase( ).indexOf( b.toLowerCase( ) ) === 0
    const inUsernameFirstLast = User => beginsWith(User.Username,search) || beginsWith(User.FirstName,search) || beginsWith(User.LastName,search)
    if( search.length < 3 || ! this.activeSearch.length ) {
      return this.props.following
          .filter( inUsernameFirstLast )
          .sort( (a,b) => a.Username < b.Username? -1: 1 )
          .slice(0,5)
          .map(this.userRow)
    } else if( this.activeSearch.length ) {
      return this.activeSearch.slice(0,5).map(this.userRow)
    }
  }
  render( ) {
    const { change, focus, send } = this.props
    let inputStyle = { paddingHorizontal : 10
                     , fontSize : Fonts.size.input, flex : 1
                     , backgroundColor : 'white'
                     , marginLeft : 10, marginTop : 10, marginBottom : 10
                     , borderRadius: 3
                     }
    , showUsers = this.activeTag ? true : false
    return (<KeyboardAvoidingView
              ref="keyboard"
              behavior="padding"
              keyboardVerticalOffset={isIPhoneX( ) ? 132 : 108}>
      <View style={{ flexDirection : 'column', width : '100%', position : 'absolute'
                  , display : (showUsers ? 'flex' : 'none'), alignItems : 'center', justifyContent : 'flex-end'
                  , top : -250, left : 0, height : 250 }}>
        { this.tagResults ( ) }
      </View>
      <View style={{ height : 80, flexDirection : 'row', backgroundColor : '#eee' }}>

        <TextInput multiline={true} value={this.value}
          style={inputStyle} onChangeText={this.onChange} onFocus={this.onFocus}
          onSelectionChange={this.onSelect}
          placeholder="make a comment..." />

        <TouchableOpacity onPress={this.onSend} style={{ alignSelf: 'center', padding: 5, justifyContent: 'center' }}>
          <SvgAirPlane size={30} />
        </TouchableOpacity>

      </View>

    </KeyboardAvoidingView>)
  }
}
